// extracted by mini-css-extract-plugin
export default {"inputBox":"inputBox___z9SVg","inputBoxField":"inputBoxField____0iEO"};